// extracted by mini-css-extract-plugin
module.exports = {"icon":"Sport_icon__1WEjy","active":"Sport_active__SRm9A"};